import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useAppSelector, useAppDispatch } from "store/index";
import { handleUpdateFields } from "store/liveOps/tournaments/slice";

import InnerInput from "components/inputs/InnerInput/InnerInput";
import SwitchBtn from "components/buttons/SwitchBtn";

const SCORES_FIELDS = [
  "multiplier",
  "weight",
  "minValue",
  "maxValue",
  "isActive",
];

interface Props {
  activeMetric: string;
  setActiveMetric: (e: string) => void;
  fieldErrors?: Record<string, string>;
  clearFieldError: (field: string) => void;
  clearFieldsErrors: (field: string[]) => void;
  readOnly?: boolean;
}

const metricsList: string[] = [
  "betAmount",
  "betCount",
  "winAmount",
  "winCount",
];

const TournamentsScoresTab: React.FC<Props> = ({
  activeMetric,
  setActiveMetric,
  fieldErrors,
  clearFieldError,
  clearFieldsErrors,
  readOnly
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const payload = useAppSelector((store) => store.tournaments.payload);
  const currentItem = payload?.scores?.filter(
    (el) => el?.metric === activeMetric,
  )[0];

  useEffect(() => {
    clearFieldsErrors(SCORES_FIELDS);
  }, [activeMetric]);

  const handleDataScores = (key: string, value: string | number) => {
    if (currentItem && payload?.scores) {
      // @ts-ignore
      dispatch(
        handleUpdateFields({
          ...payload,
          scores: [
            ...payload?.scores?.filter((el) => el?.metric !== activeMetric),
            {
              ...currentItem,
              metric: activeMetric,
              [key]: value,
            },
          ],
        }),
      );
    } else {
      const config = payload?.scores
        ? payload?.scores?.filter((el) => el?.metric !== activeMetric)
        : [];
      dispatch(
        // @ts-ignore
        handleUpdateFields({
          ...payload,
          scores: [
            // @ts-ignore
            ...config,
            // @ts-ignore
            {
              metric: activeMetric,
              [key]: value,
            },
          ],
        }),
      );
    }
  };

  return (
    <div className="tournament-rules">
      <div className="game-modal-tabs bonus-currencies-tabs small">
        {metricsList?.map((el) => (
          <div
            className={`tab-item ${activeMetric === el ? "active" : ""}`}
            key={el}
            onClick={() => {
              setActiveMetric(el);
            }}
          >
            <div className="currency-tab-item">{t(el)}</div>
          </div>
        ))}
      </div>
      <div className="tournament-rules-form">
        <div className="row row-2">
          <div className="bonus-form-box--item">
            <InnerInput
              value={currentItem?.multiplier?.toString() ?? ""}
              placeholder={t("multiplier")}
              label={t("multiplier")}
              type="number"
              id="scores-multiplier"
              onChange={(e) => {
                handleDataScores("multiplier", e);
                clearFieldError("multiplier");
              }}
              hasError={Boolean(fieldErrors?.["multiplier"])}
              disabled={readOnly}
            />
          </div>
          <div className="bonus-form-box--item">
            <InnerInput
              value={currentItem?.weight?.toString() ?? ""}
              placeholder={t("weight")}
              label={t("weight")}
              type="number"
              id="scores-weight"
              onChange={(e) => {
                handleDataScores("weight", e);
                clearFieldError("weight");
              }}
              hasError={Boolean(fieldErrors?.["weight"])}
              disabled={readOnly}
            />
          </div>
        </div>
        <div className="row">
          <div className="bonus-form-box--item">
            <InnerInput
              value={currentItem?.minValue?.toString() ?? ""}
              placeholder={t("minValue")}
              label={t("minValue")}
              type="number"
              id="scores-minValue"
              onChange={(e) => {
                handleDataScores("minValue", e);
                clearFieldError("minValue");
              }}
              hasError={Boolean(fieldErrors?.["minValue"])}
              disabled={readOnly}
            />
          </div>
          <div className="bonus-form-box--item">
            <InnerInput
              value={currentItem?.maxValue?.toString() ?? ""}
              placeholder={t("maxValue")}
              label={t("maxValue")}
              type="number"
              id="scores-maxValue"
              onChange={(e) => {
                handleDataScores("maxValue", e);
                clearFieldError("maxValue");
              }}
              hasError={Boolean(fieldErrors?.["maxValue"])}
              disabled={readOnly}
            />
          </div>
          <div className="bonus-form-box--item">
            <SwitchBtn
              activeTxt={t("active")}
              isActive={!!currentItem?.isActive}
              handleClick={() => {
                handleDataScores("isActive", !!currentItem?.isActive ? 0 : 1);
                clearFieldError("isActive");
              }}
              hasError={Boolean(fieldErrors?.["isActive"])}
              disabled={readOnly}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TournamentsScoresTab;
